import { useState } from 'react';
import KargguLogo from "../svg/LogotipoKarggu_rojo.svg";
import { getTrackingInfo } from '../services/trackingService';

export default function Tracking() {
  const [input, setInput] = useState('');
  // const [guiaList, setGuiaList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState([]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
    setError('');
  };

  const handleSearch = async () => {
    let guias = input
      .split(',')
      .map(g => g.trim())
      .filter(g => g.length > 0);

    if (guias.length === 0 || guias.length > 15) {
      setError('Ingresa hasta 15 números de rastreo separados por coma.');
      setResults([]);
      return;
    }

    // setGuiaList(guias);
    setLoading(true);
    setError('');
    try {
      const response = await getTrackingInfo(guias);
      const envios = Array.isArray(response.data) ? response.data : [];
      setResults(envios);
    } catch (err) {
      setError('No se pudo obtener la información de rastreo.');
      setResults([]);
    }
    setLoading(false);
  };

  const toggleExpand = (idx) => {
    setExpanded((prev) =>
      prev.includes(idx) ? prev.filter(i => i !== idx) : [...prev, idx]
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="min-h-screen bg-[#f8f8f8] flex flex-col">
      {/* Header */}
      <div className="flex items-center px-8 py-8">
        <a href="/"><img src={KargguLogo} alt="Karggu logo" className="h-14 w-auto" /></a>
      </div>
      {/* Main content */}
      <div className="flex flex-col items-center justify-center flex-1 px-4">
        <h1 className="text-[#ea1300] text-3xl md:text-4xl font-bold mb-2 text-center">Rastrea tu envío</h1>
        <p className="text-gray-300 mb-8 text-center max-w-xl">
          Ingresa tu número de rastreo (máximo 15, separados por coma) y presiona <span className="font-semibold">Enter</span> para buscar tu paquete.
        </p>
        <div className="w-full max-w-xl flex flex-col items-center">
          <input
            type="text"
            value={input}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Ejemplo: 123456, 789012, 345678"
            className="w-full px-6 py-4 rounded-2xl bg-[#23232a] text-white text-lg focus:outline-none focus:ring-2 focus:ring-[#ea1300] transition mb-2"
            maxLength={300}
          />
          {error && <span className="text-red-400 mb-2">{error}</span>}
        </div>
        {loading && (
          <div className="mt-8 text-white animate-pulse">Buscando...</div>
        )}
        {/* Resultados */}
        {!loading && results.length > 0 && (
          <div className="w-full max-w-5xl mt-8 space-y-6">
            {results.map((r, idx) => {
              const lastState = Array.isArray(r.stateHistory) && r.stateHistory.length > 0
                ? r.stateHistory[r.stateHistory.length - 1]
                : null;
              let entregaEstimada = '';
              if (r.requestedDate && r.estimatedDays) {
                const fecha = new Date(r.requestedDate);
                fecha.setDate(fecha.getDate() + Number(r.estimatedDays));
                entregaEstimada = fecha.toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
              }
              let size = null;
              if (r.size && (r.size.width || r.size.height || r.size.deep || r.size.weight)) {
                size = r.size;
              } else if (r.resize && (r.resize.width || r.resize.height || r.resize.deep || r.resize.weight)) {
                size = r.resize;
              }
              const origen = r.places && r.places.pickup && r.places.pickup.address;
              const destino = r.places && r.places.delivery && r.places.delivery.address;
              return (
                <div key={r.guia || idx} className="bg-[#e9e9e9] rounded-2xl shadow-lg p-6 relative">
                  {/* Imagen solo en pantallas menores a md, esquina superior derecha */}
                  {r.providerData.logo && (
                    <img
                      src={r.providerData.logo}
                      alt={r.providerData.name || 'Logo proveedor'}
                      className="block md:hidden h-16 w-auto rounded absolute right-4 top-4"
                      style={{ maxWidth: 80 }}
                    />
                  )}
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                    <div className='flex flex-col'>
                      <span className="text-[#ea1300] font-bold">Guía:</span>
                      <span className="text-[#18181c] font-semibold">{r.guia || r.folio}</span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-[#ea1300] font-bold">Estatus:</span>
                      <span className="text-[#18181c] font-semibold flex flex-row flex-wrap items-center">
                        {lastState ? lastState.name : 'Sin información'}
                        {lastState && lastState.date && (
                          <span className="text-gray-400 text-xs ml-2 inline md:block">({new Date(lastState.date).toLocaleString('es-MX')})</span>
                        )}
                      </span>
                    </div>
                    <div className="flex flex-col">
                      <span className="text-[#ea1300] font-bold">Entrega programada:</span>
                      <span className="text-[#18181c] font-semibold">{entregaEstimada || 'Sin información'}</span>
                    </div>
                    {!r.providerData.logo && (
                      <div className="flex flex-col">
                        <span className="text-[#ea1300] font-bold">Proveedor:</span>
                        <span className="text-[#18181c] font-semibold flex items-center">
                          {r.providerData.name || 'Sin información'}
                        </span>
                      </div>
                    )}
                    <button
                      className="mt-4 md:mt-0 px-4 py-2 bg-[#ea1300] text-white rounded-lg font-semibold hover:bg-[#c11200] transition"
                      onClick={() => toggleExpand(idx)}
                    >
                      {expanded.includes(idx) ? 'Ocultar' : 'Detalles'}
                    </button>
                  </div>
                  {expanded.includes(idx) && (
                    <div className="mt-6 border-t border-[#d1d1d1] pt-4 grid gap-4 md:grid-cols-2">
                      {/* Medidas */}
                      <div className='flex flex-col'>
                        <div>
                          <span className="block text-[#ea1300] font-bold mb-1">Medidas:</span>
                          {size ? (
                            <ul className="text-[#18181c] text-sm ml-2">
                              {size.width && <li className="text-sm">Ancho: {size.width} cm</li>}
                              {size.height && <li className="text-sm">Alto: {size.height} cm</li>}
                              {size.deep && <li className="text-sm">Profundidad: {size.deep} cm</li>}
                              {size.weight && <li className="text-sm">Peso: {size.weight} kg</li>}
                            </ul>
                          ) : (
                            <span className="text-gray-500 text-sm">Sin información</span>
                          )}
                        </div>
                        {/* Pago contra entrega */}
                        {r.pagoContraEntrega && (
                          <div className="md:col-span-2 mt-2">
                            <span className="inline-block bg-yellow-200 text-[#ea1300] py-1 rounded font-bold">Pago contra entrega: <span className='text-[#000] font-normal'>${r.price}</span></span>
                          </div>
                        )}
                      </div>
                      {/* Direcciones */}
                      <div>
                        <span className="block text-[#ea1300] font-bold mb-1">Origen:</span>
                        {origen ? (
                          <div className="text-[#18181c] text-sm ml-2">
                            <div>{origen.streetAndNumber || ''} #{origen.numExterior || ''}, {origen.colony || ''}</div>
                            <div>{origen.city || ''}, {origen.state || ''}, {origen.zipCode || ''}</div>
                          </div>
                        ) : (
                          <span className="text-gray-500">Sin información</span>
                        )}
                        <span className="block text-[#ea1300] font-bold mb-1 mt-4">Destino:</span>
                        {destino ? (
                          <div className="text-[#18181c] text-sm ml-2">
                            <div>{destino.streetAndNumber || ''} #{destino.numExterior || ''}, {destino.colony || ''}</div>
                            <div>{destino.city || null}, {destino.state || ''}, {destino.city || ''}, {destino.zipCode || ''}</div>
                          </div>
                        ) : (
                          <span className="text-gray-500">Sin información</span>
                        )}
                      </div>
                      {/* Historial de status */}
                      <div className="md:col-span-2 mt-2">
                        <span className="block text-[#ea1300] font-bold mb-1">Historial de estatus:</span>
                        {Array.isArray(r.stateHistory) && r.stateHistory.length > 0 ? (
                          <ul className="text-[#18181c] text-sm ml-2">
                            {r.stateHistory.map((st, i) => (
                              <li key={i}>
                                <span className="font-semibold">{st.name}</span> - <span className='text-sm'>{new Date(st.date).toLocaleString('es-MX')}</span>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <span className="text-gray-500">Sin historial</span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}